import { FC } from "react";
import { IconProps } from ".";

export const FacebookIcon: FC<IconProps> = ({
  color = "currentColor",
  size = 1,
}) => (
  <svg
    width={11 * size}
    height={22 * size}
    viewBox="0 0 11 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.48056 3.68546H10.352V0.243266C10.0291 0.196359 8.91873 0.0908203 7.62558 0.0908203C4.92739 0.0908203 3.07905 1.88318 3.07905 5.17745V8.20921H0.101562V12.0573H3.07905V21.7399H6.7296V12.0582H9.58666L10.0402 8.21012H6.72874V5.55901C6.7296 4.44679 7.01317 3.68546 8.48056 3.68546V3.68546Z"
      fill={color}
    />
  </svg>
);
export const TwitterIcon: FC<IconProps> = ({
  color = "currentColor",
  size = 1,
}) => (
  <svg
    width={24 * size}
    height={20 * size}
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.6762 2.49014C22.8311 2.88164 21.9306 3.14114 20.9918 3.26714C21.9576 2.65814 22.6947 1.70114 23.0413 0.547641C22.1408 1.11464 21.1466 1.51514 20.087 1.73864C19.232 0.777141 18.0134 0.181641 16.684 0.181641C14.1047 0.181641 12.0282 2.39264 12.0282 5.10314C12.0282 5.49314 12.0594 5.86814 12.1361 6.22514C8.26294 6.02564 4.83573 4.06514 2.5334 1.07864C2.13145 1.81514 1.89568 2.65814 1.89568 3.56564C1.89568 5.26964 2.72656 6.78014 3.96508 7.65464C3.21657 7.63964 2.48227 7.41014 1.86017 7.04864C1.86017 7.06364 1.86017 7.08314 1.86017 7.10264C1.86017 9.49364 3.47507 11.4796 5.59275 11.9371C5.21353 12.0466 4.80022 12.0991 4.37128 12.0991C4.07302 12.0991 3.77191 12.0811 3.48927 12.0151C4.0929 13.9636 5.8058 15.3961 7.84253 15.4426C6.25746 16.7521 4.24488 17.5411 2.06612 17.5411C1.68405 17.5411 1.31761 17.5231 0.951172 17.4736C3.01489 18.8791 5.46066 19.6816 8.09818 19.6816C16.6712 19.6816 21.3582 12.1816 21.3582 5.68064C21.3582 5.46314 21.3511 5.25314 21.3412 5.04464C22.2658 4.35164 23.0427 3.48614 23.6762 2.49014Z"
      fill={color}
    />
  </svg>
);
export const InstagramIcon: FC<IconProps> = ({
  color = "currentColor",
  size = 1,
}) => (
  <svg
    width={24 * size}
    height={24 * size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.37891 0H15.9008C19.8223 0 23.0023 3.3585 23.0023 7.5V16.5C23.0023 20.6415 19.8223 24 15.9008 24H7.37891C3.45742 24 0.277344 20.6415 0.277344 16.5V7.5C0.277344 3.3585 3.45742 0 7.37891 0ZM15.9007 21.75C18.6419 21.75 20.8718 19.395 20.8718 16.5V7.5C20.8718 4.605 18.6419 2.25 15.9007 2.25H7.37878C4.63758 2.25 2.40769 4.605 2.40769 7.5V16.5C2.40769 19.395 4.63758 21.75 7.37878 21.75H15.9007Z"
      fill={color}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.95898 12C5.95898 8.6865 8.50274 6 11.6402 6C14.7776 6 17.3214 8.6865 17.3214 12C17.3214 15.3135 14.7776 18 11.6402 18C8.50274 18 5.95898 15.3135 5.95898 12ZM8.08925 12C8.08925 14.067 9.68284 15.75 11.64 15.75C13.5972 15.75 15.1908 14.067 15.1908 12C15.1908 9.9315 13.5972 8.25 11.64 8.25C9.68284 8.25 8.08925 9.9315 8.08925 12Z"
      fill={color}
    />
    <ellipse cx="17.7473" cy="5.54999" rx="0.75708" ry="0.7995" fill={color} />
  </svg>
);
